// @flow

import { useParams } from 'react-router-dom';
import { Text, View } from 'reshaped';

import { selectOrder, type OrderItem } from '@gandi/billing';
import { selectCountTotalProducts } from '@gandi/cart';
import { useTranslator } from '@gandi/translate';

import { selectIsPricing } from 'src/Cart/modules/selectors';
import { useAppSelector } from 'src/hooks/useAppSelector';

type Props = { beforeTaxes?: number, currency?: string };

function filterDiscounts(item: OrderItem) {
  return item.item_type !== 'discount';
}

export function TotalArticles({
  beforeTaxes,
  currency,
}: Props): React.MixedElement | null {
  const { __, formatPrice } = useTranslator();

  const params = useParams<{ orderId: string }>();
  const orderId = parseInt(params.orderId, 10);
  const order = useAppSelector(state => selectOrder(state, { orderId }));
  const cartTotalProducts = useAppSelector(selectCountTotalProducts);
  const displayPlaceholder = useAppSelector(selectIsPricing);

  const totalProducts = order
    ? order.items.filter(filterDiscounts).length
    : cartTotalProducts;
  if (beforeTaxes === undefined) return null;

  return (
    <View direction="row" justify="space-between">
      <Text variant="body-2" weight="bold" as="p">
        {__('%(count)s articles', {
          count: totalProducts,
        })}
      </Text>
      {!displayPlaceholder && (
        <Text variant="body-2" weight="bold" as="p">
          {formatPrice(beforeTaxes, currency)}
        </Text>
      )}
    </View>
  );
}
